<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li  class="SideMenuLinksInner">
            <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
              <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>NFO</span>
            </a>
          </li> -->
          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/data-upload-status"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/data-upload-status.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Data Upload Status</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate" [ngClass]="IsMobile ? 'p' : ''">
      <span *ngIf="!IsMobile" class="SectionHeading">
        Data Upload Status Report
      </span>

      <div
        *ngIf="IsMobile"
        class="CommonSelectBoxTabsOuter CommonSelectBoxForm">
        <div class="SectionTopHeading HeadingReport NewHeaders fixed-top p-0">
          <span class="Mob_Heading_Top">Resources</span>
        </div>
        <div
          class="ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs">
          <ul class="nav nav-tabs p-0 Reports_Mob">
            <li>
              <a
                routerLink="/value-add-service/branding"
                routerLinkActive="active">
                Branding Images
              </a>
            </li>
            <li>
              <a
                routerLink="/value-add-service/scheme-returns"
                routerLinkActive="active">
                Scheme Returns
              </a>
            </li>
            <li class="d-none">
              <a
                routerLink="/value-add-service/schemeperformancelumpsum"
                routerLinkActive="active">
                Lumpsum Performance
              </a>
            </li>
            <li>
              <a
                routerLink="/value-add-service/new-nfo"
                routerLinkActive="active">
                NFO
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="TopFilters"
        [ngClass]="
          IsMobile
            ? 'ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs hmp'
            : ''
        ">
        <div>
          <!-- <div class="SearchBox" *ngIf='!IsMobile'>
                  <input type="text" placeholder="Search Fund" #SeacrhFund class="ExploreSearch"
                      [(ngModel)]="SearchFund" (keyup)="MakeSearchFundArr($event.target.value)" />
                      <!-- <input type="text" placeholder="Search Fund" #SeacrhFund class="ExploreSearch"
                      /> -->
          <!--<img type="image/svg+xml" class="searchicon svg" src="../../assets/images/IFA/SearchBlue.svg" />
              </div> -->
          <br />
          <form form [formGroup]="FilterForm">
            <div *ngIf="!IsMobile" class="row">
              <div
                class="class=col-md-2 col-md-2 col-sm-2 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(0)"
                      name="CheckFilter"
                      value="1" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp;All RTA</label>
                  </label>
                </div>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect0"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(2)"
                      name="CheckFilter"
                      value="2" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp;CAMS</label>
                  </label>
                </div>
              </div>
              <div
                class="class=col-md-4 col-md-4 col-sm-4 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect2"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(3)"
                      name="CheckFilter"
                      value="3" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp;KFintech</label>
                  </label>
                </div>
              </div>
            </div>

            <div *ngIf="IsMobile" class="d-flex">
              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(0)"
                      name="CheckFilter"
                      value="1" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp;ALL RTA</label>
                  </label>
                </div>
              </div>

              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect0"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(2)"
                      name="CheckFilter"
                      value="2" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp; CAMS</label>
                  </label>
                </div>
              </div>
              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect2"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="BindAutoUploadStatus(3)"
                      name="CheckFilter"
                      value="3" />
                    <span class="checkmark"></span>
                    <label>&nbsp;&nbsp;KFintech</label>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <br />
      <div
        id="TblReportSection"
        class="MainInnerFormWithoutFlex IFA_Mob_Margin mt-0">
        <div
          id="AutoUploadReportdiv"
          class="table-responsive"
          *ngIf="AutoUploadData.length > 0">
          <h6><b class="d-none">Data Upload Status Report</b></h6>
          <table id="AutoUploadReportTable" class="CommonTable ClsReportTable">
            <thead>
              <tr>
                <th>RTA</th>
                <th>ARN</th>
                <th>Date & Time</th>
                <th class="text-right">RTA Filename</th>
                <th>Status</th>
                <th class="text-right">Total Records</th>
                <th class="text-right">Inserted</th>
                <th class="text-right">Updated</th>
                <th>Rejected</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of AutoUploadData">
                <td>{{ c.RTA }}</td>
                <td>{{ c.ARN }}</td>
                <td>{{ c.UploadTime }}</td>
                <td class="text-right">
                  <span
                    class="tooltiplink CursorPointer"
                    attr.data-target="{{ c.FileName }}"
                    autoPlacement="true">
                    {{ c.FileName | slice: 0 : 20 }}...
                  </span>
                </td>
                <td>{{ c.Status }}</td>
                <td class="text-right">
                  <span>{{ c.TotalRecordInFile }}</span>
                </td>
                <td class="text-right">
                  <span>{{ c.InsertRecord }}</span>
                </td>
                <td class="text-right">
                  <span>{{ c.UpdateRecord }}</span>
                </td>
                <td>{{ c.RejectRecord }}</td>
              </tr>
            </tbody>
            <!-- <tfoot >
                           <tr class="GrandTotalBG">
                               <th colspan="3">Grand Total</th>
                               <th class="text-right"></th>
                               <th class="text-right"></th>
                               <th class="text-right"></th>
                               <th class="text-right"></th>
                               <th class="text-right"></th>
                               <th class="text-right"></th>
                           </tr>
                       </tfoot> -->
          </table>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!IsMobile">
    <app-footer></app-footer>
  </span>
</div>
